import type {
  ConvertLeadInput,
  CreateLeadInput,
  DeleteRecordsInput,
  LeadBulkPatch,
  LeadImportJsonInput,
  LogLeadActivityInput,
  PlanLeadContactsInput,
  UpdateLeadInput
} from '@shared/types';
import { showUndoToastForLastAction } from '@renderer/app/undo/undo-toast';
import { getDesktopApi } from '@renderer/lib/desktop-api';

export async function listLeads() {
  return getDesktopApi().leads.listLeads();
}

export async function getLeadById(leadId: string) {
  return getDesktopApi().leads.getLeadById(leadId);
}

export async function createLead(payload: CreateLeadInput) {
  return getDesktopApi().leads.createLead(payload);
}

export async function updateLead(payload: UpdateLeadInput) {
  const result = await getDesktopApi().leads.updateLead(payload);
  void showUndoToastForLastAction();
  return result;
}

export async function applyBulkLeadPatch(payload: LeadBulkPatch) {
  const result = await getDesktopApi().leads.applyBulkPatch(payload);
  void showUndoToastForLastAction();
  return result;
}

export async function planLeadContacts(payload: PlanLeadContactsInput) {
  const result = await getDesktopApi().leads.planContacts(payload);
  void showUndoToastForLastAction();
  return result;
}

export async function logLeadActivity(payload: LogLeadActivityInput) {
  return getDesktopApi().leads.logLeadActivity(payload);
}

export async function convertLead(payload: ConvertLeadInput) {
  return getDesktopApi().leads.convertLead(payload);
}

export async function previewLeadImport(payload: LeadImportJsonInput) {
  return getDesktopApi().leads.previewLeadImport(payload);
}

export async function importLeadsJson(payload: LeadImportJsonInput) {
  const result = await getDesktopApi().leads.importLeadsJson(payload);
  void showUndoToastForLastAction();
  return result;
}

export async function exportLeadsJson() {
  return getDesktopApi().leads.exportLeadsJson();
}

export async function saveLeadsJsonFile(content: string, title: string) {
  const date = new Date().toISOString().slice(0, 10);
  return getDesktopApi().system.saveTextFile({
    title,
    defaultFileName: `alttvision-leaduri-${date}.json`,
    content,
    filters: [{ name: 'JSON', extensions: ['json'] }]
  });
}

export async function readTextFromClipboard() {
  return getDesktopApi().system.readClipboardText();
}

export async function writeTextToClipboard(text: string) {
  return getDesktopApi().system.writeClipboardText({ text });
}

export async function deleteLeads(payload: DeleteRecordsInput) {
  const result = await getDesktopApi().leads.deleteLeads(payload);
  void showUndoToastForLastAction();
  return result;
}

export async function listDeletedLeads() {
  return getDesktopApi().leads.listDeletedLeads();
}

export async function restoreLeads(payload: DeleteRecordsInput) {
  return getDesktopApi().leads.restoreLeads(payload);
}

export async function purgeLeads(payload: DeleteRecordsInput) {
  return getDesktopApi().leads.purgeLeads(payload);
}
